<template lang="pug">
  .about
    h1(v-html='headline')
    seperator
    .body
      p(v-for='paragraph in body', v-html='paragraph')
      router-link.cta(to='/kontakt') Kontakt
    .clear
</template>

<script>
  import seperator from '@/components/Seperator'
  export default {
    components: {
      seperator
    },
    data () {
      return {
        title: 'Kaffeehaus',
        indicator: require('@/assets/img/donauhof-about.svg'),
        image: require('@/assets/img/donauhof-about-image.jpg'),
        background: {
          rotate: -50,
          scale: {
            x: 2,
            y: 14
          },
          translate: {
            x: '-65%',
            y: '0%'
          }
        },
        headline: 'Der Donauhof soll neben klassischen Vermietungen, Platz für innovative Projekte bieten.',
        body: [
          'Abseits von Kaffehaus, Ballsaal & Coworking Space, findet in Zukunft auch eine Möbelwerkstatt Einzug in den Donauhof. Ein Beispiel für viele Projekte, die sich durch gemeinsame Arbeit ergeben haben. ',
          'Für Ideen zu Kooperationen, gemeinsamen Veranstaltungen & Projekten könnt ihr gerne jederzeit mit uns in Kontakt treten. '
        ]
      }
    },
    head () {
      return {
        title: this.title
      }
    }
    // created () {
    //   this.$parent.currentIndicator = this.indicator
    //   this.$parent.currentImage = this.image
    // }
  }
</script>

<style lang="scss" scoped>
  @import "~utils";
</style>



// WEBPACK FOOTER //
// About.vue?4b25567a